module.exports = __webpack_public_path__ + "img/4.fe98dfbc.jpg";